import * as React from "react";
import Box from "@mui/material/Box";
import "@fontsource/lato";
import "@fontsource/montserrat";
import Avatar from "@mui/material/Avatar";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
// @ts-ignore
import {Button, Modal} from "@mui/material";
// @ts-ignore
import {Theme} from "../../Components/styles/styles";
import clsx from "clsx";
import css from "./CompanyProfileApla.module.css";
import {OperationalContact} from "./OperationalContact.tsx";
import Profile from "../Model/Profile.ts";
import {JSX, useState} from "react";

// import {OperationalContact} from "./OperationalContact.tsx";

export interface InfoListItem {
    header: string;
    list: any;
    imageUrl?: string;
}

export interface CompanyProfileAplaProps {
    profile: Profile;
    token: string;
    menuIx: number;
    cardName: string;
    infoList: InfoListItem[];
    icon?: string | null;
    companyName?: string;
    // fileDownloadBoxHeader?: string | null;
}

export const CompanyProfileApla = React.forwardRef<HTMLDivElement, CompanyProfileAplaProps>(
    (
        props,
        ref
    ): JSX.Element => {

        const [edit, setEdit] = useState(false);

        const [changed, setChanged] = useState(false);

        const drawView = (includeChildren: boolean = true): JSX.Element => {

            return (
                <Box className={clsx(css.companyProfileApla)}>

                    <Box className={clsx(css.header)}>

                        <Box className={clsx(css.icon)}>
                            <Avatar className={clsx(css.avatar)} src={props.icon || ''}></Avatar>
                        </Box>

                        <Box className={clsx(css.cardName)}>
                            <Box>{props.cardName}</Box>
                        </Box>

                        <Box className={clsx(css.button)}>
                            {
                                !edit && (
                                    <Button
                                        variant="outlined"
                                        startIcon={<EditOutlinedIcon/>}
                                        sx={{
                                            ...Theme.OrangeButton,
                                            fontSize: 14,
                                            minWidth: 111,

                                            [Theme.breakpoints.down("laptop")]: {
                                                fontSize: 12,
                                            },
                                        }}
                                        onClick={() => {
                                            setEdit(true);
                                        }}
                                    >
                                        Edycja
                                    </Button>
                                )
                            }
                        </Box>

                    </Box>


                    <Box className={clsx(css.interior)}>
                        <Box className={clsx(css.content)}>
                            {includeChildren && (
                                <OperationalContact profile={props.profile}
                                                    token={props.token}
                                                    menuIx={props.menuIx}
                                                    edit={edit}
                                                    setEdit={setEdit}
                                                    onChanged={(changed) => setChanged(changed)}
                                />
                            )}
                        </Box>
                    </Box>
                </Box>
            );
        }


        // @ts-ignore
        const onKeyDown = (event) => {
            console.log('KeyDown called', event.key);
            switch (event.key) {
                case 'Escape':
                    if (changed) {
                        handleConfirmClose();
                    } else {
                        setEdit(false);
                        setChanged(false)
                    }
                    break;
            }
        }


        const handleConfirmClose = () => {
            const confirmed = window.confirm('Masz niezapisane zmiany. Czy na pewno chcesz zamknąć formularz bez zapisywania?');
            if (confirmed) {
                setChanged(false);
                setEdit(false);
            }
        }


        const drawEdit = () => {
            return (
                <Modal
                    open={true}
                    onKeyDown={onKeyDown}
                    closeAfterTransition
                    slotProps={{
                        backdrop: {
                            timeout: 500,
                        },
                    }}
                >
                    <Box
                        className="modal"
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                        }}
                    >
                        {drawView(true)}
                    </Box>
                </Modal>
            )
        }


        return (
            <Box ref={ref}>
                {edit ? drawEdit() : drawView()}
            </Box>
        )
    }
);
